<template>
    <div class="aboutUs">
        <HeaderReturn title="关于我们"></HeaderReturn>

        <div class="aboutUs_ul">
            <div>
                <img src="../../assets/img/page/kf.png" />
                <p>TY </p>
            </div>
            <ul>
                <li v-for="(item, index) in TeamList" :key="item.id" @click="goLink(item.path)">
                    <div class="d-flex justify-between">
                        <p>
                            {{ item.txt }}

                        </p>
                        <img src="../../assets/img/page/jt.png" alt="" srcset="" style="width: 30px;height: 30px;">
                    </div>

                </li>
            </ul>
        </div>
    




    </div>
</template>
<script>
import Vue from 'vue';
import { NoticeBar, Icon } from 'vant';
Vue.use(NoticeBar).use(Icon);
import vueQr from "vue-qr";
export default {
    components: {
        vueQr,
    },
    data() {
        return {
            baseApi: "",
            UrlYqhy: "",
            Aeccter: {
                money: 75.8193,

            },
            TeamList: [
                {
                    txt: "隐私政策",
                    id: 0,
                    path: ''
                },
                {
                    txt: "用户协议",
                    id: 1,
            

                },
                {
                    txt: "版本日志",
                    id: 2
                },
                {
                    txt: "版本更新",
                    id: 3
                }
            ],



        }
    },
    created() {
        this.baseApi = process.env.VUE_APP_IMG;
        this.UrlYqhy = window.location.origin + '/#/reg?promotion=' + '1111';
    },
    methods: {
        onCopy() {
            this.$toast(this.$t('myself.a23'))
        },
        goLink(path, item) {
            if (path) {
                this.$router.push({
                    path,
                    query: {
                        item: JSON.stringify(item),
                    }
                });
            } else {
                // 暂未开放
                this.$toast(this.$t('orePond.a42'));
            }
        }

    }
}
</script>
<style lang="scss" scoped="scoped">
// 引入全局的样式
@import "@/assets/scss/base.scss";

.aboutUs {
    margin: 50px 10px;

    ::v-deep .van-nav-bar__title {
        color: #f89b19;
        font-size: 20px;
        font-weight: 600;
    }

    .aboutUs_ul {

        margin: 120px 0;

        img {
            width: 166px;
            height: 166px;

        }

        text-align: center;
        ul {
            li {
                margin: 20px 10px;
           
                border: 1px solid #f89b19;
                border-radius: 4px;

                div {
                    &:nth-child(1) {
                        padding: 10px 15px;

                        p {
                            font-style: normal;
                            font-weight: 400;
                            font-size: 14px;
                            line-height: 30px;
                            text-align: center;

                            color: #FFFFFF;




                        }
                    }



                }
            }
        }
    }




}</style>